// https://km.sankuai.com/collabpage/1607987736
// import { raptor } from '@wmfe/mach-pro-utils';
import {
  getI18nParams, getRegion, getCityId
} from '@m2h/common/utils';

const getDefaultTags = () => ({
  i18n: getI18nParams(),
  unionid: window.Owl?.cfgManager.getExtension('unionId'),
  os: window.Owl.cfgManager.getExtension().os || '',
});

export const owlAddError = (err, opts) => {
  try {
    if (window.Owl) {
      window.Owl.addError(err, { level: 'info', ...opts });
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('OWL 自定义上报异常：', e);
  }
};

const gen = (category = 'jsError', level = 'info') => ({ type, message, tags }) => {
  const err = {
    name: type || 'sailor_fe_c_machpro_h5_error',
    msg: message,
  };
  const _defaultTags = getDefaultTags();
  return owlAddError(
    err,
    {
      category,
      level,
      tags: { ..._defaultTags, ...tags },
    },
  );
};

// 自定义上报，默认info级别，避免造成大面积告警
// err: 可为string | {name,msg}对象 | Error对象
// tags: Object, 自定义异常信息
// opts: 覆盖owlAddError配置
const genWeb = (category = 'jsError', level = 'info') => (
  err,
  tags: any = getDefaultTags() || {},
  opts = { level }
) =>
  owlAddError(
    err,
    {
      category,
      tags: { ...tags, ...getDefaultTags() },
      ...opts,
    },
  );

export const owlAddJsInfo = genWeb('jsError');
export const owlAddAjaxInfo = genWeb('ajaxError');
export const owlAddResourceInfo = genWeb('resourceError');

export const owlAddJsError = genWeb('jsError', 'error');
export const owlAddAjaxError = genWeb('ajaxError', 'error');
export const owlAddResourceError = genWeb('resourceError', 'error');

export const reportBusinessException = gen('jsError', 'error');
// const metricInstance = null;
let metricInstance = window.Owl?.MetricManager();

const owlReportMetricsWeb = (params) => {
  console.log('123 reportMetrics', params);
  const values = (params?.values || {}) as {[key: string]: string | number;};
  const tags = params?.tags || {};
  const extraString = params?.extraString;
  let imetricInstance: null | Owl.MetricsInstance = metricInstance;
  if (!imetricInstance) {
    imetricInstance = window.Owl?.MetricManager();
  }
  if (imetricInstance) {
    const [metricName, metricValue] = Object.entries(values)[0] || [];
    metricName && imetricInstance.setMetric(metricName, metricValue);
    imetricInstance.setTags(tags);
    extraString && imetricInstance.setExtraData(extraString);
  }
};

// 上报自定义指标，PC、APP内都会上报，上报项目不同
// https://km.sankuai.com/page/1291907878#id-%E8%87%AA%E5%AE%9A%E4%B9%89%E6%8C%87%E6%A0%87
// TODO： 通用tag？ app侧添加
export const owlReportMetricsWebPC = (valuesDic = {}, tagsDic = {}, options: { extraString?: string; owlProjectName?: string; } = {}) => {
  // console.log('123 reportMetrics h5', valuesDic, tagsDic);
  let imetricInstance = metricInstance;
  if (!imetricInstance) {
    imetricInstance = window.Owl?.MetricManager();
  }
  if (options?.owlProjectName && window.owl) {
    let newInst = window.owl('createInstance', {
      project: options?.owlProjectName || 'com.sankuai.sailorfe.bp.exception',
    });
    imetricInstance = newInst && newInst.MetricManager();
  }
  if (!imetricInstance) return; // 还是没有实例化成功
  const [metricName, metricValue] = Object.entries(valuesDic)[0] || [];
  metricName && imetricInstance.setMetric(metricName, metricValue as string);
  imetricInstance.setTags({
    area: getRegion(),
    region: getRegion(),
    cityId: getCityId(),
    ...tagsDic,
  });
  options?.extraString && imetricInstance.setExtraData(options?.extraString);
};
export const owlReportMetricsPC = (valuesDic = {}, tagsDic = {}, options = {}) => {
  try {
    owlReportMetricsWebPC(valuesDic, tagsDic, options);
  } catch (error) {
    console.log(error);
  }
};

const Raptor = {
  reportBusinessException,
  reportMetrics: owlReportMetricsWebPC,
  owlReportMetrics: owlReportMetricsWebPC,
  // reportMetrics: owlReportMetricsWeb,
  // owlReportMetrics: owlReportMetricsWeb,
};

export const owlReportMetrics = owlReportMetricsPC;

export default Raptor;
